<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <a-result status="info" title="子商品已并入主商品盒子编辑" sub-title="请到「现货商品」或「定制商品」中编辑主商品，在「子商品盒子」页签维护配件/阶梯价/发货规则。本独立菜单保留接口兼容，不再作为日常入口。">
        <template #extra>
          <a-button type="primary" @click="$router.push('/dkmall/goods')">去现货商品</a-button>
          <a-button style="margin-left:8px" @click="$router.push('/dkmall/custom-goods')">去定制商品</a-button>
        </template>
      </a-result>
    </a-card>
  </page-header-wrapper>
</template>
<script>
export default { name: 'DkSubProductRetired' }
</script>
